import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import usePageSeo from '../hooks/usePageSeo';

const POPULAR = [
  { name: 'Audit Services', path: '/audit-services-uae' },
  { name: 'Accounting Services', path: '/accounting-services-uae' },
  { name: 'Corporate Tax', path: '/corporate-tax-uae' },
  { name: 'VAT Services', path: '/vat-services-uae' },
  { name: 'goAML Compliance', path: '/services/goaml-compliance' },
  { name: 'UAE Free Zone Services', path: '/free-zone-services-uae' }
];

export default function NotFound() {
  usePageSeo({ title: 'Page Not Found', description: 'The page you are looking for does not exist.', noindex: true });

  return (
    <section className="min-h-[70vh] pt-36 pb-20 px-4 bg-white" data-testid="not-found-page">
      <div className="container mx-auto max-w-3xl">
        <p className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Error 404</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mt-3 mb-4">This page could not be found</h1>
        <p className="text-gray-600 mb-10">The link may be outdated or mistyped. These pages are a good place to start:</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {POPULAR.map((p) => (
            <Link
              key={p.path}
              to={p.path}
              className="group flex items-center justify-between border border-gray-200 rounded-xl px-5 py-4 hover:border-teal-500 transition-colors"
              data-testid={`not-found-link-${p.path.replace(/\//g, '-').replace(/^-/, '')}`}
            >
              <span className="font-medium text-gray-800">{p.name}</span>
              <ArrowRight size={18} className="text-teal-600 transition-transform group-hover:translate-x-1" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
